export default __webpack_public_path__ + "static/media/avatar-3.2cfd5ba6.jpg";